import React from 'react';
import '../../../smsgateway/layout/SmsSkeleton.css';

function MediaGridSkeleton({ count = 10 }) {
    return (
        <div className="row g-2 row-cols-2 row-cols-sm-3 row-cols-md-4 my-files-grid">
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className="col">
                    <div className="ecx-page-list-item overflow-hidden h-100">
                        <div className="my-files-skeleton__preview">
                            <div className="sms-skeleton" style={{ aspectRatio: '4 / 3' }} />
                        </div>
                        <div className="p-2 px-4">
                            <div className="sms-skeleton mb-2" style={{ width: '80%', height: '14px' }} />
                            <div className="sms-skeleton mb-3" style={{ width: '55%', height: '12px' }} />
                            <div className="d-flex gap-2">
                                <div className="sms-skeleton flex-grow-1" style={{ height: '31px', borderRadius: '0.375rem' }} />
                                <div className="sms-skeleton" style={{ width: '31px', height: '31px', borderRadius: '0.375rem' }} />
                                <div className="sms-skeleton" style={{ width: '31px', height: '31px', borderRadius: '0.375rem' }} />
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default MediaGridSkeleton;
